import { createStore, applyMiddleware, compose } from "redux";
import rootReducer from "./rootReducer";
import thunk from "redux-thunk";

const logger = (store) => (next) => (action) => {
  return next(action);
};

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const isDevelopment = process.env.NODE_ENV === "development";

// Middleware yang digunakan
const middleware = [thunk];

if (isDevelopment) {
  middleware.push(logger);
}

const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(logger, thunk))
);

export default store;
